import React from "react";

// Real Aurelo brand assets extracted from the official branding sheet.
const LOGO_DARK = "/brand/aurelo_logo_v3.png";        // full-colour wordmark (navy text) — for LIGHT surfaces
const LOGO_WHITE = "/brand/aurelo_logo_white_v2.png"; // white wordmark — for DARK surfaces
const ICON_APP = "/brand/aurelo_icon.png";         // rounded-square app icon (white bg + gradient A)
const ICON_WHITE = "/brand/aurelo_icon_white.png"; // white line-art A mark — for DARK surfaces

// App/brand mark.
//  `light`  => white line-art icon (use on dark navy surfaces, e.g. collapsed sidebar)
//  default  => rounded-square app icon (use on light surfaces / floating chips)
export const AureloMark = ({ size = 32, light = false, className = "" }) => (
  <img
    src={light ? ICON_WHITE : ICON_APP}
    alt="Aurelo"
    draggable={false}
    className={`block object-contain select-none ${className}`}
    style={{ height: size, width: "auto", maxWidth: "100%" }}
  />
);

// Horizontal Aurelo logo (icon + wordmark). `size` = pixel height, width auto to preserve ratio.
//  `light` => white version for dark backgrounds.
export const AureloLogo = ({ size = 30, light = false, className = "" }) => (
  <img
    src={light ? LOGO_WHITE : LOGO_DARK}
    alt="Aurelo"
    draggable={false}
    className={`block object-contain select-none ${className}`}
    style={{ height: size, width: "auto", maxWidth: "100%" }}
  />
);
